export function filter(predicate) {
    return function (stream) {
        return {
            subscribe() {
                return {
                    *[Symbol.iterator]() {
                        let subscription = yield* stream.subscribe();
                        return {
                            *next() {
                                while (true) {
                                    let next = yield* subscription.next();
                                    if (next.done) {
                                        return next;
                                    }
                                    else if (yield* predicate(next.value)) {
                                        return next;
                                    }
                                }
                            },
                        };
                    },
                };
            },
        };
    };
}
//# sourceMappingURL=filter.js.map